import $ from 'jquery';

export default () => {
  const $contactForms = $(".contact-form");
  const $previewFileModal = $('#preview-modal');
  
  $contactForms.on('click', '.pdf-preview-modal-caller', function (e) {
    const $this = $(this);

    if ($('body').hasClass('pdf-support')) {
      e.preventDefault();
      e.stopPropagation();

      const src = $this.attr('href');
      const $pdfContainer = $previewFileModal.find('#pdf-container');
      $previewFileModal.find('#accept-terms').data('target', $this.closest('label'));
      
      // Is pdf already loaded?
      if ($pdfContainer.attr('src') !== src) {
        $pdfContainer.attr('src', src);
      }

      $previewFileModal.addClass('show');
    } else {
      $this.attr('target', '_blank');
    }
  });

  $previewFileModal.on('click', '#accept-terms', function(e) {
    const $this = $(this);
    const $checkbox = $(`#${$this.data('target').prop('for')}`);

    $checkbox.prop('checked', true);
    $checkbox.trigger('change');
    $this.data('target', null);
    $previewFileModal.removeClass('show');
  });
}